export default __webpack_public_path__ + "static/char-s-35-en-9593eb898d6829906eb012037dfdfebc.webp";